(function () {
  const MILESTONES = [2, 4, 5, 6];
  const PERCENTS = [5, 10, 15, 20];

  function getDiscount(count) {
    for (let i = MILESTONES.length - 1; i >= 0; i--) {
      if (count >= MILESTONES[i]) return PERCENTS[i];
    }
    return 0;
  }

  function formatMoney(cents, fmt) {
    if (!fmt) return (cents / 100).toFixed(2);
    const n = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/gi, n)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/gi, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/gi, (cents / 100).toLocaleString());
  }

  function getProgressWidthForCount(n) {
    if (n <= 0) return 0;
    if (n < 2) return 21 * n;
    if (n === 2) return 42;
    if (n === 3) return 51.16;
    if (n === 4) return 60.33;
    if (n === 5) return 78.66;
    return 99.99;
  }

  function countVariant(units, variantId) {
    return units.filter((u) => u.variantId === variantId).length;
  }

  function triggerConfetti() {
    const container = document.createElement('div');
    container.style.position = 'fixed';
    container.style.top = '0';
    container.style.left = '0';
    container.style.width = '100vw';
    container.style.height = '100vh';
    container.style.pointerEvents = 'none';
    container.style.zIndex = '9999';
    document.body.appendChild(container);

    const colors = ['#804B92', '#593863', '#BDB498', '#EDE6D8', '#2A002A'];
    for (let i = 0; i < 40; i++) {
      const p = document.createElement('div');
      p.style.position = 'absolute';
      p.style.width = `${Math.random() * 8 + 4}px`;
      p.style.height = `${Math.random() * 12 + 6}px`;
      p.style.background = colors[Math.floor(Math.random() * colors.length)];
      p.style.left = `${Math.random() * 100}vw`;
      p.style.top = `-20px`;
      p.style.opacity = String(Math.random() * 0.5 + 0.5);
      p.style.transform = `rotate(${Math.random() * 360}deg)`;
      p.style.transition = `transform 1.5s linear, top 1.5s cubic-bezier(0.1, 0.8, 0.3, 1), opacity 1.5s ease-out`;

      container.appendChild(p);

      setTimeout(() => {
        p.style.top = `${window.innerHeight + 20}px`;
        p.style.transform = `rotate(${Math.random() * 1000 - 500}deg) translate(${Math.random() * 100 - 50}px)`;
        p.style.opacity = '0';
      }, 50);
    }

    setTimeout(() => {
      container.remove();
    }, 2000);
  }

  /**
   * Updates a single card's quantity UI (no full grid re-render).
   */
  function applyQuantityControl(card, qty, totalUnits, max) {
    const ui = card.querySelector('[data-byb-qty-ui]');
    const inc = card.querySelector('[data-byb-qty-inc]');
    const dec = card.querySelector('[data-byb-qty-dec]');
    const display = card.querySelector('[data-byb-qty-display]');
    const stepper = card.querySelector('[data-byb-stepper]');
    const addBtn = card.querySelector('[data-byb-qty-add]');

    if (!ui || !display || !stepper) return;

    const atCapacity = totalUnits >= max;
    const canInc = !atCapacity;

    card.classList.toggle('byb__card--has-qty', qty > 0);
    ui.classList.toggle('byb__card-qty-ui--empty', qty === 0);
    ui.classList.toggle('byb__card-qty-ui--active', qty > 0);

    display.textContent = String(Math.max(0, qty));
    if (inc) {
      inc.disabled = !canInc;
      inc.tabIndex = qty > 0 ? 0 : -1;
    }
    if (dec) dec.tabIndex = qty > 0 ? 0 : -1;
    if (addBtn) {
      addBtn.tabIndex = qty === 0 ? 0 : -1;
      addBtn.setAttribute('aria-hidden', qty > 0 ? 'true' : 'false');
    }

    stepper.setAttribute('aria-hidden', qty === 0 ? 'true' : 'false');
  }

  function triggerQtyBounce(displayEl) {
    if (!displayEl) return;
    displayEl.classList.remove('byb__card-qty-value--pop');
    void displayEl.offsetWidth;
    displayEl.classList.add('byb__card-qty-value--pop');
    const end = () => {
      displayEl.classList.remove('byb__card-qty-value--pop');
      displayEl.removeEventListener('animationend', end);
    };
    displayEl.addEventListener('animationend', end, { once: true });
  }

  function init(root) {
    if (!root) return;
    const max = parseInt(root.dataset.maxSlots || '6', 10);
    const fmt = root.dataset.moneyFormat || '';

    /** @type {{ variantId: number, price: number, image: string, title: string }[]} */
    const units = [];
    const els = {
      slots: root.querySelectorAll('[data-byb-slot]'),
      cta: root.querySelector('[data-byb-cta]'),
      ctaText: root.querySelector('[data-byb-cta-text]'),
      progressFill: root.querySelector('[data-byb-progress-fill]'),
      progressLabels: root.querySelectorAll('[data-byb-progress-label]'),
      cards: root.querySelectorAll('[data-byb-card]'),
    };

    function sync() {
      const n = units.length;
      const discount = getDiscount(n);
      const total = units.reduce((s, x) => s + x.price, 0);
      const final = Math.round(total * (1 - discount / 100));

      const prevDiscount = parseInt(root.dataset.prevDiscount || '-1', 10);
      if (prevDiscount >= 0 && discount > prevDiscount) {
        triggerConfetti();
      }
      root.dataset.prevDiscount = String(discount);

      if (els.ctaText) els.ctaText.textContent = `Start Calm | ${formatMoney(final, fmt)}`;
      els.cta?.toggleAttribute('disabled', n === 0);

      if (els.progressFill) {
        els.progressFill.style.width = `${getProgressWidthForCount(n)}%`;
      }
      els.progressLabels?.forEach((el) => {
        el.classList.toggle('byb__progress-dot--active', discount >= parseInt(el.dataset.percent || '0', 10));
      });

      els.slots.forEach((slot, i) => {
        const item = units[i];
        const filled = !!item;
        slot.classList.toggle('byb__slot--filled', filled);
        slot.classList.toggle('byb__slot--empty', !filled);
        const img = slot.querySelector('.byb__slot-img');
        const rm = slot.querySelector('.byb__slot-remove');
        if (img) {
          img.style.display = filled ? 'block' : 'none';
          if (filled) {
            img.src = item.image;
            img.alt = item.title;
          }
        }
        if (rm) {
          rm.style.display = filled ? 'flex' : 'none';
          rm.onclick = (ev) => {
            ev.stopPropagation();
            removeAtSlot(i);
          };
        }
      });

      const atMax = n >= max;
      els.cards?.forEach((c) => {
        const vid = parseInt(c.dataset.variantId, 10);
        const q = countVariant(units, vid);
        const disableCard = atMax && q === 0;
        c.classList.toggle('byb__card--disabled', disableCard);
        applyQuantityControl(c, q, n, max);
      });

      const summary = root.querySelector('[data-byb-selection-summary]');
      if (summary) {
        if (n === 0) {
          summary.innerHTML = 'Add items to start building your bundle';
        } else if (n === 1) {
          summary.innerHTML = 'Add <strong>1 more item</strong> to unlock <strong>5% OFF</strong>!';
        } else if (n === 2) {
          summary.innerHTML = '🎉 <strong>5% OFF unlocked!</strong> Add 2 more to get <strong>10% OFF</strong>!';
        } else if (n === 3) {
          summary.innerHTML = 'Add <strong>1 more item</strong> to unlock <strong>10% OFF</strong>!';
        } else if (n === 4) {
          summary.innerHTML = '🎉 <strong>10% OFF unlocked!</strong> Add 1 more to get <strong>15% OFF</strong>!';
        } else if (n === 5) {
          summary.innerHTML = '🎉 <strong>15% OFF unlocked!</strong> Add 1 more to get <strong>20% OFF</strong>!';
        } else {
          summary.innerHTML = '🔥 <strong>Max discount unlocked! 20% OFF!</strong>';
        }
        summary.hidden = false;
      }
    }

    function addUnit(variantId, price, image, title) {
      if (units.length >= max) return false;
      units.push({ variantId, price, image, title });
      return true;
    }

    function removeOneVariant(variantId) {
      for (let i = units.length - 1; i >= 0; i--) {
        if (units[i].variantId === variantId) {
          units.splice(i, 1);
          return true;
        }
      }
      return false;
    }

    function removeAtSlot(index) {
      units.splice(index, 1);
      sync();
    }

    function handleCardAction(card, action) {
      const variantId = parseInt(card.dataset.variantId, 10);
      const price = parseInt(card.dataset.price || '0', 10);
      const image = card.dataset.image || '';
      const title = card.dataset.title || '';

      let shouldBounce = false;
      if (action === 'inc' || action === 'add') {
        shouldBounce = addUnit(variantId, price, image, title);
      } else if (action === 'dec') {
        removeOneVariant(variantId);
      }
      sync();
      if (shouldBounce) triggerQtyBounce(card.querySelector('[data-byb-qty-display]'));
    }

    root.addEventListener('click', (e) => {
      const decBtn = e.target.closest('[data-byb-qty-dec]');
      const incBtn = e.target.closest('[data-byb-qty-inc]');
      const card = e.target.closest('[data-byb-card]');

      if (card) {
        if (card.classList.contains('byb__card--disabled') || card.dataset.soldOut === 'true') return;
        
        if (decBtn) {
          e.preventDefault();
          e.stopPropagation();
          handleCardAction(card, 'dec');
        } else if (incBtn) {
          e.preventDefault();
          e.stopPropagation();
          handleCardAction(card, 'inc');
        } else {
          e.preventDefault();
          handleCardAction(card, 'add');
        }
        return;
      }

      if (e.target.closest('[data-byb-cta]')) {
        e.preventDefault();
        if (units.length === 0) return;
        const cart = document.querySelector('cart-drawer');

        const quantities = {};
        for (const u of units) {
          quantities[u.variantId] = (quantities[u.variantId] || 0) + 1;
        }
        const variantIds = Object.keys(quantities).map((id) => parseInt(id, 10));

        els.cta?.classList.add('byb__cta--loading');

        (async function () {
          const items = variantIds.map((id) => ({ id, quantity: quantities[id] }));
          const body = { items };
          if (cart) {
            body.sections = cart.getSectionsToRender().map((s) => s.id);
          }
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
          });
          const data = await res.json();
          if (data.status) throw new Error(data.description || 'Error adding to cart');
          if (cart) {
            cart.classList.remove('is-empty');
            cart.renderContents(data);
            cart.setActiveElement?.(document.activeElement);
            cart.open?.();
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
          units.length = 0;
          sync();
        })().catch((err) => {
          alert(err.message || 'Error adding to cart');
        }).finally(() => els.cta?.classList.remove('byb__cta--loading'));
      }
    });

    root.addEventListener('keydown', (e) => {
      const addBtn = e.target.closest('[data-byb-qty-add]');
      if (addBtn && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        addBtn.click();
      }
    });

    sync();
  }

  document.querySelectorAll('[data-byb-section]').forEach(init);
})();
